var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.3996L8 20.6996V11.2996L16 6.59961L24 11.2996V20.6996L16 25.3996ZM10 19.5996L16 23.0996L22 19.5996V12.4996L16 8.99961L10 12.4996V19.5996Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 8.2L17 2.3C16.7 2.1 16.4 2 16 2C15.6 2 15.3 2.1 15 2.3L5 8.2C4.4 8.6 4 9.2 4 9.9V22.1C4 22.8 4.4 23.5 5 23.8L15 29.7C15.3 29.9 15.7 30 16 30C16.3 30 16.7 29.9 17 29.7L27 23.8C27.6 23.4 28 22.8 28 22.1V9.9C28 9.2 27.6 8.5 27 8.2ZM26 22.1L16 28L6 22.1V9.9L16 4L26 9.9V22.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemPage);
export default __webpack_public_path__ + "static/media/redeem-page.1be78a3a45a73f10792cad594fe84b3c.svg";
export { ForwardRef as ReactComponent };